export default "__VITE_ASSET__CAyv7sHi__"